import {
  CurrencyListType,
  LookupCampaignTeamMemberListType,
  LookupCountryListType,
  LookupCountryType,
  LookupGetCampaignItemsTerminologyResponseType,
  LookupOrganizationByNameOrEinListType,
  LookupOrganizationListType,
  LookupOrganizationsByPartnerType,
  LookupRegionsType,
  LookupTemplatesListType,
  LookupTimezoneListType,
} from 'src/models/Lookup';
import { ApiFunctionNoParamType, ApiFunctionType, httpGet, httpGetCancellable, httpPost } from 'src/utils/http';

const path = '/lookup'; // be aware of base 64 encoding. some APIs may return a raw JSON

/** list of countries */
export const apiGetCountries = (): Promise<LookupCountryListType> => httpPost(`${path}/countries`);

/** list of regions by country id */
export const apiGetRegionsByCountryId = (id: LookupCountryType['ID']): Promise<LookupRegionsType> =>
  httpPost(`${path}/regions`, { countryId: id });

/** app currencies list */
export const apiGetCurrencyList = (): Promise<CurrencyListType> => httpGet(`${path}/listcurrencies`);

/** list of timezones */
export const apiGetTimezones = (): Promise<LookupTimezoneListType> => httpPost(`${path}/timezones`);

export const apiGetOrganizationsByName = (term: string): Promise<LookupOrganizationListType> =>
  httpGet(`${path}/organizationsList`, { term });

export const apiGetOrganizationsByPartner = (term: string): Promise<LookupOrganizationsByPartnerType> =>
  httpGet(`${path}/organizationsbypartnerList`, { term });

export const apiGetCampaignMembers: ApiFunctionType<
  {
    term: string;
    campaignId: string | number;
  },
  LookupCampaignTeamMemberListType
> = httpGetCancellable(`${path}/teammembersList`);

export const apiGetCampaignMembersOld = (
  term: string,
  campaignId: string | number
): Promise<LookupCampaignTeamMemberListType> => httpGet(`${path}/teammembersList`, { term, campaignId });

export const apiGetCampaignMembersCancellable: ApiFunctionType<
  {
    term: string;
    campaignId: string | number;
  },
  LookupCampaignTeamMemberListType
> = httpGetCancellable(`${path}/teammembersList`);

export const apiGetCampaignTeams: ApiFunctionType<
  {
    term: string;
    campaignId: string | number;
    limit: number;
    draftContributionId?: number;
  },
  LookupCampaignTeamMemberListType
> = httpGetCancellable(`${path}/teamslist`);

export const apiGetCampaignTeamsOld = (
  term: string,
  campaignId: string | number
): Promise<LookupCampaignTeamMemberListType> => httpGet(`${path}/teamslist`, { term, campaignId });

export const apiGetCampaignTeamsOldCancellable: ApiFunctionType<
  {
    term: string;
    campaignId: string | number;
    limit: number;
  },
  LookupCampaignTeamMemberListType
> = httpGetCancellable(`${path}/teamslist`);

/** organizations by name or EIN */
export const apiGetOrganizationsByNameAndEin: ApiFunctionType<
  { term: string; limit: number },
  LookupOrganizationByNameOrEinListType
> = httpGetCancellable(`${path}/OrganizationsByNameAndEinList`);

export const apiGetNonFeaturedTemplates: ApiFunctionNoParamType<LookupTemplatesListType> = httpGetCancellable(
  `${path}/NonFeaturedTemplates`
);

export const apiGetCampaignItemsTerminology: ApiFunctionType<
  { permanentUrl: string },
  LookupGetCampaignItemsTerminologyResponseType
> = httpGetCancellable(`${path}/GetCampaignItemsTerminology`);
